import { useEffect } from "react";
import React from "react";
// import Countdown from "./Countdown";

function NewStudents() {
  useEffect(() => {
    document.title = "New Students";
  });
  return (
    <div class="content">
      <div class="w-container">
        <div class="page-head">
          <div class="page-title">
            <h1 class="h1">New Students</h1>
          </div>
          <div class="flex-vert">
            <div class="sub-hrule"></div>
            <p class="paragraph-center sub">
              This page contains everything you need to know about <span style={{color: "goldenrod", fontWeight: 'bold'}}>Wiess O-Week</span>. 
              Read about what to expect for move-in below, and find everything else 
              in the O-Week book linked at the bottom of this page.
            </p>
          </div>
        </div>
        <div class="sub-head" style={{ marginTop: '70px' }}>
          <h2 class="h3">O-Week Book</h2>
          <div class="sub-hrule"></div>
          <a
            style={{ marginTop: "2%", marginBottom: "6%" }}
            data-w-id="7807c01e-0929-1697-07ed-9b89da4c4bcf"
            href="https://drive.google.com/file/d/1ITZoyKkjP6gqrvfjUmuLjKFc-rsuJyer/view"
            class="w-inline-block"
          >
            <img
              src="/images/new-students/oweekbook.png"
              srcset="/images/new-students/oweekbook-p-500.png 500w, images/new-students/oweekbook-p-800.png 800w, images/new-students/oweekbook-p-1080.png 1080w, images/new-students/oweekbook.png 1600w"
              sizes="(max-width: 479px) 92vw, (max-width: 767px) 94vw, (max-width: 991px) 728px, 940px"
              data-w-id="5a43e2e8-260e-ceb9-9db0-111b860959f1"
              alt="Oweek book"
            />
          </a>
          <img
            src="/images2026-27/misc/welcome-to-wiess.jpeg"
            alt="O-Week 2025"
            style={{ display: 'block', width: '100%', height: 'auto', marginBottom: '40px' }}
          />
        </div>
        <div class="sub-head">
          <h2 class="h3">Mission Statement</h2>
          <div class="sub-hrule"></div>
        </div>
        <div class="sub-head" style={{ marginBottom: '30px' }}>
          <h3 class="h3">Why “Team Family Wiess”?</h3>
        </div>
        <div class="flex-vert" style={{ marginBottom: '40px' }}>
          <p class="paragraph-center sub">
            At Wiess, you're not just part of a college; you're part of a family. Our wonderful
            Core Team, Head Fellows, and Fellows will provide you with a community that
            supports, accepts, and uplifts you through every stage of your journey at Rice
            University. Wiess O-Week 2026 values loyalty, care, and support as the heart of
            Team Family Wiess, fostering an environment where students feel comfortable to learn,
            connect, and grow. Through upholding our core values of
            empathy, inclusivity, diversity, and integrity, we strive to build a culture where all
            new students feel empowered. Wiess College is your launchpad: a home that grounds you 
            with tradition while encouraging you to pursue excellence and take on new challenges 
            with confidence. O-Week is not just about the
            connections you form in one week– it's about building relationships and a support
            system that will last far beyond your time at Rice. Regardless of where
            new students find themselves at Rice, they will always have a home here at 
            Wiess.
          <br /> <br />
          <p>TFW Forever,</p>
          Jaden, Eva, Alena<br />
          </p>
        </div>
        <div class="ns-section">
          <div class="sub-head">
            <h2 class="h3">Additional Resources</h2>
            <div class="sub-hrule"></div>
          </div>
          <div class="flex-vert">
            <a
              href="https://www.instagram.com/wiessoweek2026/"
              class="form-link w-inline-block"
            >
              <h3 class="h3">Instagram</h3>
            </a>
            <a
              href="https://www.youtube.com/watch?v=-Kxycbg8uoU"
              class="form-link w-inline-block"
            >
              <h3 class="h3">Room Tour Video</h3>
            </a>
            <a
              href="https://www.youtube.com/watch?v=niJLyuonnNQ"
              class="form-link w-inline-block"
            >
              <h3 class="h3">Wiess Introduction Video</h3>
            </a>
            <a
              href="https://success.rice.edu/first-year-programs/o-week"
              class="form-link w-inline-block"
            >
              <h3 class="h3">Rice First Year Programs Website</h3>
            </a>
            <a
              href="https://success.rice.edu/first-year-programs/o-week/new-student-checklist"
              class="form-link w-inline-block"
            >
              <h3 class="h3">New Student Checklist</h3>
            </a>
            <a
              href="https://success.rice.edu/first-year-programs/o-week/o-week-faqs"
              class="form-link w-inline-block"
            >
              <h3 class="h3">O-Week FAQ</h3>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NewStudents;
